import { Injectable } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root'
})
export class LogSharedService<LogShared> extends SupabaseDatabaseService<LogShared>  {

  async getShareLogByLogId(logId:string): Promise<LogShared>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.LOGS_SHARED)
    .select(`
      id,
      log_id,
      psychologist_id,
      user_id
    `)
    .eq('log_id', Number(logId))
    .maybeSingle();

    if (error) {
      console.error(`Erro ao buscar SHARED LOG pendentes em '${TYPES.DATABASE.TABLES.LOGS_SHARED}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as LogShared);

  }

  async deleteByUserIdAndPsychologistId(userId: number | string, psychologistId: number | string): Promise<void> {
    const { error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.LOGS_SHARED)
      .delete()
      .eq('user_id', userId)
      .eq('psychologist_id', psychologistId);

    if (error) {
      console.error(`Erro ao deletar em '${TYPES.DATABASE.TABLES.LOGS_SHARED}':`, error);
      throw new Error(error.message);
    }
  }

  async updateAllByUserId(userId: number | string, psychologistId: number | string): Promise<void> {
    const { error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.LOGS_SHARED)
      .update({psychologist_id : psychologistId})
      .eq('user_id', userId);

    if (error) {
      console.error(`Erro ao atualizar em '${TYPES.DATABASE.TABLES.LOGS_SHARED}':`, error);
      throw new Error(error.message);
    }
  }

}
